module.exports = __webpack_public_path__ + "static/media/success-illustration.4647754a.svg";